import { isEmpty, get } from 'lodash-es';
import { CREATED } from 'srcAlias/client/enums/accountCreationStatus';

const isRefer = (response) => {
  return (
    !isEmpty(response) &&
    isEmpty(response.error) &&
    get(response, 'data.data.applicationStatus') === 'REFER'
  );
};

const isTechnicalError = (response) =>
  response && response.error !== null && response.data === null;

const isAccept = (response) => {
  return (
    !isEmpty(response) &&
    isEmpty(response.error) &&
    get(response, 'data.data.applicationStatus') === 'ACCEPT'
  );
};
const IsBaseAccountNumberPresent = (response) => {
  const investmentAccountDetails = get(
    response,
    'data.data.investmentAccounts',
    []
  );

  const res = investmentAccountDetails.filter(
    (account) =>
      account.investmentAccountIdentifier &&
      account.openAccountStatus === CREATED
  );

  return isEmpty(res) ? false : true;
};

export const applicationSubmitResponsePresent = (response) => {
  return (
    (!isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.data.applicationStatus)) ||
    (!isEmpty(response) && !isEmpty(response.error))
  );
};

export const checkResponse = (applicationSubmitResponse) => {
  if (isTechnicalError(applicationSubmitResponse)) {
    return 'TECHNICAL_ERROR_PAGE';
  }

  if (isRefer(applicationSubmitResponse)) {
    return 'REFER_PAGE';
  }

  if (isAccept(applicationSubmitResponse)) {
    if (IsBaseAccountNumberPresent(applicationSubmitResponse)) {
      return 'ACCEPT_PAGE';
    }
    return 'REFER_PAGE';
  }
  return undefined;
};
